import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function QuickLinkCard({ title, description, icon: Icon, href, image }) {
    // We keep the prop name "href" for compatibility, but route with RouterLink.
    return (
        <Card
            elevation={1}
            sx={{
                position: 'relative',
                borderRadius: 2,
                transition: 'transform 0.2s',
                '&:hover': { transform: 'translateY(-4px)', boxShadow: 6 },
            }}
        >
            <CardActionArea
                component={RouterLink}
                to={href}
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    textAlign: 'center',
                }}
            >
                {image && (
                    <Box
                        component="img"
                        src={image}
                        alt={title}
                        sx={{ width: '100%', height: 140, objectFit: 'cover', display: 'block' }}
                    />
                )}

                <CardContent sx={{ position: 'relative', width: '100%' }}>
                    {Icon && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                            <Icon fontSize="large" sx={{ color: '#002F6C' }} />
                        </Box>
                    )}
                    <Typography variant="h6" component="h3">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
